// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-tooltip-resize {\n  width: 200px;\n  word-break: break-word;\n}\n.v-tooltip__content {\n  background: #001e38;\n  color: #fff;\n}\n.v-tooltip__content:after {\n  content: \"\";\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  border-left: 15px solid transparent;\n  border-right: 15px solid transparent;\n  border-top: 15px solid #001e38;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -10px;\n}\n", ""]);
// Exports
module.exports = exports;
